/* eslint-disable no-tabs */
import React from 'react';
import PropTypes from 'prop-types';

const MasterCard = ({fill, style, ...rest}) => (
  <svg id="svg2985" style={{enableBackground: 'new 0 0 564.5 366.9', ...style}} version="1.1" viewBox="0 0 564.5 366.9" >
    <g id="g3125" transform="matrix(1.2152823,0,0,1.2152823,-67.025868,-37.711623)">
      <g id="g3115">
        <g id="g3110">
          <path style={{fill: '#F79F1A'}}
                d="M519.7,182.2c0,79.5-64.3,143.9-143.6,143.9s-143.6-64.4-143.6-143.9S296.7,38.3,376,38.3     S519.7,102.7,519.7,182.2L519.7,182.2z"
                id="path2997"/>
          <path
            style={{fill: '#EA001B'}}
            d="M342.4,182.2c0,79.5-64.3,143.9-143.6,143.9S55.2,261.7,55.2,182.2S119.5,38.3,198.8,38.3     S342.4,102.7,342.4,182.2L342.4,182.2z"
            id="path2995"/>
          <path style={{fill: '#FF5F01'}}
                d="M287.4,68.9c-33.5,26.3-55,67.3-55,113.3s21.5,87,55,113.3     c33.5-26.3,55-67.3,55-113.3S320.9,95.3,287.4,68.9z"
                id="path2999"/>
        </g>
        <g id="g3043"
           transform="matrix(1.2704171,0,0,1.2704171,507.53053,240.70315)">
          <g id="text3045">
            <path style={{fill: '#F79F1A'}}
                  d="M9.3,14.1v-4H8.3l-1.2,2.8L5.9,10H4.8v4h0.7v-3l1.1,2.6      h0.8L8.6,11v3.1H9.3z M2.6,14.1v-3.4H4V10H0.6v0.7h1.4v3.4H2.6z"
                  id="path3057"/>
          </g>
          <g id="text3047"/>
        </g>
      </g>
    </g>
  </svg>
);

MasterCard.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.object,
  rest: PropTypes.object,
};

MasterCard.defaultProps = {
  fill: '#09183A',
  style: {},
  rest: {},
};

export default MasterCard;



// WEBPACK FOOTER //
// ./src/assets/MasterCard.jsx